import { Component, OnInit } from '@angular/core';
import { SkillDto } from 'src/app/models/SkillDto';
import { SkillsService } from 'src/app/services/skills.service';

@Component({
  selector: 'app-view-skill',
  templateUrl: './view-skill.component.html',
  styleUrls: ['./view-skill.component.css']
})
export class ViewSkillComponent implements OnInit {


  constructor(private skillService:SkillsService ) { }
  
  Skills:SkillDto[]|undefined;
  ngOnInit(): void {
    this.loadRecords();

  }


 async  loadRecords()
  {
    let  resSkills = await this.skillService.getSkills().toPromise(); 
    this.Skills = <SkillDto[]> resSkills.responseData;

  }
}
